import { render, staticRenderFns } from "./PromoLink.vue?vue&type=template&id=9e9b590c&scoped=true&"
import script from "./PromoLink.vue?vue&type=script&lang=js&"
export * from "./PromoLink.vue?vue&type=script&lang=js&"
import style0 from "./PromoLink.vue?vue&type=style&index=0&id=9e9b590c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9b590c",
  null
  
)

export default component.exports